<template>
  <v-dialog v-model="show" max-width="440">
    <v-card v-if="refund">
      <v-card-title class="d-flex align-center justify-space-between">
        <span>{{ refund.orderRef }}</span>
        <v-chip small :color="statusMeta.color" text-color="white">
          {{ statusMeta.labelKey ? $t(statusMeta.labelKey) : "" }}
        </v-chip>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <div class="detail-row">
          <span>{{ $t("finance_customer") }}</span>
          <strong>{{ refund.customer }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_reason") }}</span>
          <strong>{{ refund.reason }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_amount") }}</span>
          <strong>{{ formatCurrency(refund.amount, restaurantCurrency) }}</strong>
        </div>

        <v-divider class="my-3" />

        <div class="detail-row">
          <span>{{ $t("finance_approved_by") }}</span>
          <strong>{{ refund.approvedBy || "—" }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_evidence") }}</span>
          <strong>{{ refund.evidence || $t("finance_not_attached") }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_comment") }}</span>
          <strong>{{ refund.comment || "—" }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_refund_method") }}</span>
          <strong>{{ refund.method || "—" }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_related_payout") }}</span>
          <strong>{{ refund.relatedPayout || "—" }}</strong>
        </div>
      </v-card-text>
      <template v-if="refund.status === 'pending' && canApprove">
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <primary-button :loading="approving" @click="$emit('approve', refund)">
            <v-icon left small>mdi-check-circle-outline</v-icon>
            {{ $t("finance_approve_refund") }}
          </primary-button>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { REFUND_STATUS_META, formatCurrency } from "../constants";

export default {
  name: "RefundDetailDialog",

  props: {
    value: { type: Boolean, default: false },
    refund: { type: Object, default: null },
    canApprove: { type: Boolean, default: false },
    approving: { type: Boolean, default: false },
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    statusMeta() {
      return (this.refund && REFUND_STATUS_META[this.refund.status]) || { labelKey: "", color: "grey" };
    },
  },

  methods: { formatCurrency },
};
</script>

<style scoped>
.detail-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.6);
  padding: 4px 0;
}

.detail-row strong {
  color: rgba(0, 0, 0, 0.87);
  text-align: right;
}
</style>
